export default "__VITE_ASSET__Djk6GZQS__"